package com.wintermar.inspection.feature.presentation.inspection.answer.widget.content_item_button

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import com.wintermar.inspection.core.ui.theme.AppDimension
import com.wintermar.inspection.feature.domain.model.answer.AnswerModel
import com.wintermar.inspection.graphql.type.InspectionAnswerType

@Composable
actual fun ContentItemButton(
    answer: AnswerModel,
    answerType: InspectionAnswerType,
    dimension: AppDimension,
    onShowModalNotes: () -> Unit,
    onShowModalFiles: () -> Unit,
    onShowFindingCategory: () -> Unit
) {
    if (!answer.notes.isEmpty() && !answer.files.isEmpty() && !answer.isEmptyFindingCategory()) {
        return
    }

    Row(
        modifier = Modifier.fillMaxWidth(),
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(
            dimension.spacing.space2
        )
    ) {
        ContentItemButtonView(
            answer = answer,
            answerType = answerType,
            fillWidthButton = false,
            dimension = dimension,
            onShowModalNotes = onShowModalNotes,
            onShowModalFiles = onShowModalFiles,
            onShowFindingCategory = onShowFindingCategory
        )
    }
}
